/// <reference path="ChangePassword.js" />
define('viewmodels/ChangePassword',['knockout', 'plugins/router', 'durandal/app', 'services/appsecurity', 'services/navigation', 'durandal/system', 'services/logger'],
function (ko, router, app, appsecurity, navigation, system, logger) {
    var CpViewModel = {
        activate: activate,
        attached: attached,
        appsecurity: appsecurity,
        OldPassword: ko.observable(""),
        NewPassword: ko.observable(""),
        ReEnterNewPassword: ko.observable(""),
        SubmitChangePassword: SubmitChangePassword,
        ResetForm: ResetForm,
        PasswordHelp: PasswordHelp,
        PasswordHelpToolTip: ko.observable(),
        PageType: ko.observable("Screen"),
       // PasswordLocked: ko.observable(false),
        PhoneNumber: ko.observable(),
        OtpText: ko.observable('We\'ve sent you a text message on'),
        OTPPassword: ko.observable(),
        ProviderName: ko.observable("SMSCode"),
        SubmitOnetimepassword: SubmitOnetimepassword,
        Wrongattemptcount:ko.observable(3),
        SettingTabclick: SettingTabclick,
        intialisenumber: intialisenumber,
        SubmitPhoneNumberchange: SubmitPhoneNumberchange,
        MaskedNumber: ko.observable(),
        Authenticatewithoption: Authenticatewithoption,
        AuthenticateOTP:AuthenticateOTP,
        AuthenticatewithPhoneCall: AuthenticatewithPhoneCall,
        otp: ko.observable(),
        Hideallchangepassworddivs: Hideallchangepassworddivs,
        Popuptype: ko.observable(),
        Submitoption: Submitoption,
        SendotpTotheuser: SendotpTotheuser


    };
    CpViewModel.NewPassword.subscribe(function (newValue) {
        if (newValue != undefined && newValue != "") {
            var flagValue = validatePassword(newValue);
            if (!flagValue) {
                //CpViewModel.password("");
                $('#pswd_info>ul>li>i').removeClass('fa-check').addClass('fa-close');
                $('#pswd_info>ul>li').removeClass('valid').addClass('invalid');
            }
        }
    });
    return CpViewModel;

    function activate() {
        try {
        }
        catch (e) {
            var msg = 'Exception' + e + ' Source | activate() in ChangePassword.js';
            logger.logMessage(msg);
        }
    }

    function attached() {
        try {
            //if (CpViewModel.appsecurity.Passwordlocked()) {
            //    CpViewModel.PasswordLocked(true);
            //}

            ResetForm();
           // GetPhoneNumber();
            loadJsFunctions();
            $('#loadingMainImgDiv').hide();
            $('#AuthenticateDivshell').hide();
            $('#changepassworddiv').show();
            $('#valErrorCp').hide();

        }
        catch (e) {
            var msg = 'Exception' + e + ' Source | attached() in ChangePassword.js';
            logger.logMessage(msg);
        }
    }


    function intialisenumber()
    {
        try {
            Hidealldivs();
            HideallButtonsChangephonenumber();
            GetPhoneNumber().then(function () {

                $("#Numberphonenumberchange").intlTelInput({
                    allowExtensions: true,
                    autoFormat: false,
                    autoHideDialCode: false,
                    autoPlaceholder: false,
                    defaultCountry: "auto",
                    ipinfoToken: "yolo",
                    nationalMode: false,
                    numberType: "MOBILE",
                    //onlyCountries: ['us', 'gb', 'ch', 'ca', 'do'],
                    //preferredCountries: ['cn', 'jp'],
                    preventInvalidNumbers: true,
                });
                $('#lodingimggs').hide();
                $('#changepassworddivphone').show();
                $('#submitbutton').show();
            })
        }
        catch (e) {
            var msg = 'Exception' + e + ' Source | intialisenumber() in ChangePassword.js';
            logger.logMessage(msg);
        }
    }
    function SettingTabclick(data,event)
    {
        try {

            if (event.currentTarget.id == "Profile") {
                //$('#profiledivforsettings').show();
                //$('#ChangePhoneNumberdiv').hide();
                //$('#profiledivshell').show();
                //$("#ChangePhoneNumberdiv").hide();
                //$('#SaveButton').show();
                //$('#verifyphno').hide();
                //$('#ValidateOTP').hide();
                //$('#ResendOTP').hide();
                //$('#SaveButton').show();
            }
            else {
                //$('#profiledivforsettings').hide();
                //$('#ChangePhoneNumberdiv').show();

                //$('#profiledivshell').hide();
                //$("#ChangePhoneNumberdiv").show();
                //$('#SaveButton').hide();
                //$('#verifyphno').show();
                //$('#ValidateOTP').hide();
                //$('#ResendOTP').hide();
            }
        }
        catch(e)
        {
            var msg = 'Exception' + e + ' Source | SettingTabclick() in ChangePassword.js';
            logger.logMessage(msg);
        }
    }
    function SubmitChangePassword() {
        try {
                    $('#valErrorCp').hide();

            $('#valErrorOTPCp').hide();
            //if (CpViewModel.appsecurity.TwofactorEnabled() == 'True')
            //{
            //    GetPhoneNumber();
            //}

            if (CpViewModel.OldPassword() == "") {
                //if (CpViewModel.PasswordLocked()) {
                //    $('#valErrorCp').text('One Time Password is required.');
                //    $('#valErrorCp').show();
                //}
                //else {
                    $('#valErrorCp').text('Old Password is required.');
                    $('#valErrorCp').show();
               // }

            }
            else if (CpViewModel.NewPassword() == "") {
                $('#valErrorCp').text('New Password is required.');
                $('#valErrorCp').show();
            }
            else if (CpViewModel.ReEnterNewPassword() == "") {
                $('#valErrorCp').text('Please re-enter the new password.');
                $('#valErrorCp').show();
            }
            else if (CpViewModel.ReEnterNewPassword() != CpViewModel.NewPassword()) {
                $('#valErrorCp').text('There is a mismatch between the new password and the re-entered new password.');
                $('#valErrorCp').show();
            }
            else if (CpViewModel.NewPassword().toUpperCase() == CpViewModel.OldPassword().toUpperCase()) {
                $('#valErrorCp').text('New password and the old password cannot be same.');
                $('#valErrorCp').show();
            }
            else {
                if (validatePassword(CpViewModel.NewPassword())) {
                    if (CpViewModel.appsecurity.TwofactorEnabled() == 'True') {
                        $('#valErrorCp').hide();
                        $('#lodingimgcp').show();
                        $('#AuthenticateDivshell').hide();
                        $('#changepassworddiv').hide();
                        ValidateOldPassword();
                    }
                    else {
                        ChangeUserPassword(CpViewModel.OldPassword(), CpViewModel.NewPassword());
                    }
     
                }
                else {
                    $('#valErrorCp').text('New password does not meet the password guidelines.');
                    $('#valErrorCp').show();
                }
            }
        }
        catch (e) {
            var msg = 'Exception' + e + ' Source | SubmitChangePassword() in ChangePassword.js';
            logger.logMessage(msg);
        }
    }

    function GetPhoneNumber() {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;

          return $.ajax({
                url: "/api/Account/GetPhoneNumber",
                type: "get",
                headers: headers,
                contentType: 'application/json',
            })
.success(function (jsonResult, status) {
    CpViewModel.PhoneNumber(jsonResult[0]);
    $('#Numberphonenumberchange').val(jsonResult[0]);
    $('#numberprovider').val(jsonResult[0])
    CpViewModel.MaskedNumber(jsonResult[1])
    CpViewModel.OtpText(CpViewModel.OtpText() + " " + jsonResult[1] + " with a verification code.");
})
.fail(function (error, status) {
    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in NavigatetoClientSpeceficPage() method in ProjectAuthorizeMFA.js';
    logger.logMessage(msg);
});
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetPhoneNumber() method in AuthorizeMFA.js';
            logger.logMessage(msg);
        }
    }

    function SubmitPhoneNumberchange(data,event)
    {
        try {
            $("#Numberphonenumberchange").intlTelInput({
                allowExtensions: true,
                autoFormat: false,
                autoHideDialCode: false,
                autoPlaceholder: false,
                defaultCountry: "auto",
                ipinfoToken: "yolo",
                nationalMode: false,
                numberType: "MOBILE",
                preventInvalidNumbers: true,
            });

            if ($("#Numberphonenumberchange").intlTelInput("isValidNumber")) {
                $('#valErrorPN').hide();

                var Countrycode = "+" + $("#Numberphonenumberchange").intlTelInput("getSelectedCountryData").dialCode;
                var number = $("#Numberphonenumberchange").intlTelInput("getNumber");
                number = number.substring(Countrycode.length, number.length);
                CpViewModel.PhoneNumber(Countrycode + "-" + number)
              
                CpViewModel.Popuptype('PH');

                UpdateCIAMUserPhone(CpViewModel.PhoneNumber());
            }
            else {
                $('#valErrorPN').html("Please enter a valid number.");
                $('#valErrorPN').show();
                
            }
        }
        catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source: SubmitPhoneNumberchange() method in AuthorizeMFA.js';
            logger.logMessage(msg);
        }
    }
    
    function UpdateCIAMUserPhone(number) {
        try {
            
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;

            $.ajax({
                url: "/api/Account/UpdateCIAMUserPhone?mobile=" + number,
                type: "POST",
                headers: headers,
               // data: { mobile: number }
            })
                .success(function (jsonResult, status) {
                    if (jsonResult.email != null) {
                        logger.logSuccess('Phone number is updated successfully.', 'Success', system.getModuleId(CpViewModel), true);
                    }
                    else {
                        logger.logError('An error occurred, Please contact Application Administrator.', 'Error', system.getModuleId(CpViewModel), true);
                    }

                })
                .fail(function (error, status) {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in NavigatetoClientSpeceficPage() method in ProjectAuthorizeMFA.js';
                    logger.logMessage(msg);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: Authenticatewithoption() method in AuthorizeMFA.js';
            logger.logMessage(msg);
        }
    }



   function Hidealldivs()
    {
        $('#AuthenticateDiv').hide();
        $('#changepassworddivphone').hide();
        $('#Authenticatephonecalldiv').hide();
        $('#Authenticatedivphonechange').hide();
        $('#PhonechangeOTPdiv').hide();
    }
    function Authenticatewithoption(data,event)
    {
        try {
            HideallButtonsChangephonenumber();
            if ($('#ParentQuestionDropDownphone').val() == 'PhoneCall') {
                $('#phonecallnotify').html("");
                Hidealldivs();
                $('#Authenticatephonecalldiv').show();
                $('#phonecallnotify').html("You will receive a call on "+CpViewModel.MaskedNumber() +" with a verification procedure.");
                AuthenticatewithPhoneCall();
            }
            else
            {
                $('#lodingimggs').show();
                $('#phoneOTPnotify').html("");
                Hidealldivs();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;

                $.ajax({
                    url: "/api/Account/SendOTP4PhNumChange",
                    type: "POST",
                    headers: headers,
                    data: { PhoneNumber: CpViewModel.PhoneNumber(), Isverfiedphonenumber :'false'}
                })
.success(function (jsonResult, status) {
    if (jsonResult == true) {
        logger.logSuccess('OTP has been successfully sent to the registered Number.', 'Success', system.getModuleId(CpViewModel), true);
        $('#phoneOTPnotify').html("A code has been sent to you at " + CpViewModel.MaskedNumber() + ".Enter that code below.");
        $('#validateOTPButton').show();
        $('#lodingimggs').hide();
        $('#PhonechangeOTPdiv').show();
        $('#passwordOTP').val('');
    }
    else {
        logger.logError('Unable to send OTP, Please contact Application Administrator.', 'Error', system.getModuleId(CpViewModel), true);
    }

})
.fail(function (error, status) {
    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in NavigatetoClientSpeceficPage() method in ProjectAuthorizeMFA.js';
    logger.logMessage(msg);
});
            }
        }




            
        
        catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source: Authenticatewithoption() method in AuthorizeMFA.js';
            logger.logMessage(msg);
        }
    }

   

    function AuthenticateOTP()
    {
        try {
            Hidealldivs();
                            $('#lodingimggs').show();
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;

            $.ajax({
                url: "/api/Account/ValidateOTP",
                type: "POST",
                headers: headers,
                contentType: 'application/json',

                data: JSON.stringify
                        ({
                            ProviderName: 'SMSCode',
                            PhoneNumber: CpViewModel.PhoneNumber(),
                            Isverfiedphonenumber: 'false',
                            Token: CpViewModel.otp(),

                        })
            })
            .success(function (jsonResult, status) {

                if (jsonResult == true) {
                    Hidealldivs();
                    $('#lodingimggs').hide();
                    $('#Changephonenumberpopup').modal('hide');
                    logger.logSuccess('PhoneNumber has been changed successfully.', 'Success', system.getModuleId(CpViewModel), true);
                    CpViewModel.appsecurity.logout()
.done(function (token) {
    $("input[name='__RequestVerificationToken']").val(token);
    appsecurity.clearAuthInfo();
    router.navigate('login');
})
.fail(function (error) {
    appsecurity.clearAuthInfo();
    window.location = routeconfig.login;
});
                }
                else {
                    $('#PhonechangeOTPdiv').show();
                    $('#lodingimggs').hide();
                    logger.logError('Invalid OTP entered. Please Try again.', 'Error', system.getModuleId(CpViewModel), true);
                }

            })
            .fail(function (error) {
                $('#PhonechangeOTPdiv').show();
                $('#lodingimggs').hide();
                logger.logError('An error occurred. Please Try again.', 'Error', system.getModuleId(CpViewModel), true);
            })

        }
        catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source: AuthenticatewithOTP() method in AuthorizeMFA.js';
            logger.logMessage(msg);
        }
    }

    function AuthenticatewithPhoneCall()
    {
        try {
            var status = "";
            if (CpViewModel.Popuptype() == 'PH')
            {
                status = false;
                $('#lodingimggs').show();
            }
            else {
                status = true
                $('#lodingimgcp').show();
            }
            $('#lodingimggs').show();
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;

            $.ajax({
                url: "/api/Account/VerifyWithcall",
                type: "POST",
                headers: headers,
                data: { PhoneNumber: CpViewModel.PhoneNumber(), Isverfiedphonenumber: status }
            })
            .success(function (jsonResult, status) {
                if (jsonResult == true) {
                    if (CpViewModel.Popuptype() == 'PH')
                    {
                        $('#lodingimggs').hide();
                        Hidealldivs();
                        $('#Changephonenumberpopup').modal('hide');
                        logger.logSuccess('PhoneNumber has been changed successfully.', 'Success', system.getModuleId(CpViewModel), true);
                        CpViewModel.appsecurity.logout()
.done(function (token) {
    $("input[name='__RequestVerificationToken']").val(token);
    appsecurity.clearAuthInfo();
    router.navigate('login');
})
.fail(function (error) {
    appsecurity.clearAuthInfo();
    window.location = routeconfig.login;
});
                    }
                    else
                    {
                        Hideallchangepassworddivs();
                        $('#lodingimgcp').show();
                        logger.logSuccess('PhoneNumber has been successfully verified.', 'Success', system.getModuleId(CpViewModel), true);
                        ChangeUserPassword(CpViewModel.OldPassword(), CpViewModel.NewPassword());
                    }

                }
                else {
                    if (CpViewModel.Popuptype() == 'PH') {

                        $('#lodingimggs').hide();
                        logger.logError('An error occurred. Please Try again.', 'Error', system.getModuleId(CpViewModel), true);
                    }
                    else {
                        $('#lodingimgcp').hide();
                        logger.logError('An error occurred. Please Try again.', 'Error', system.getModuleId(CpViewModel), true);
                    }
                }

            })
            .fail(function (error) { })
        }
        catch(e)
        {

        }
    }
    function ValidateOldPassword()
    {
        var key = CryptoJS.enc.Utf8.parse('8080808080808080');
        var iv = CryptoJS.enc.Utf8.parse('8080808080808080');
        var encryptedOldPassword = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(CpViewModel.OldPassword()), key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
        $('#txtOldPassword').val(encryptedOldPassword);
        var OldPwd = $('#txtOldPassword').val();

        var csrfToken = $("input[name='__RequestVerificationToken']").val();
        var headers = appsecurity.getSecurityHeaders();
        headers.__RequestVerificationToken = csrfToken;

        $.ajax({
            url: "/api/Account/ValidateOldPassword",
            type: "POST",
            headers: headers,
            contentType: 'application/json',
            data: JSON.stringify
                    ({
                        OldPassword: OldPwd,
                    })
        })
.success(function (jsonResult, status) {
    if(jsonResult==true)
    {
        $('#lodingimgcp').show();
        Hideallchangepassworddivs();

        ShowDifferentoptions();

    }
    else
    {
        $('#lodingimgcp').hide();
        Hideallchangepassworddivs();
        $('#changepassworddiv').show();
        $('#valErrorCp').text('Old password is not valid.');
        $('#valErrorCp').show();
        //show error password wont match
    }
})
.fail(function (error, status) {
    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in NavigatetoClientSpeceficPage() method in ProjectAuthorizeMFA.js';
    logger.logMessage(msg);
});
    }

   function Hideallchangepassworddivs()
    {
        $('#Authenticationdiv').hide();
        $('#Phonecallauthentication').hide();
        $('#OTPAuthentication').hide();
    }
   function Hideallpasswordchangebuttons()
    {
       $('#SubmitOTPBtn').hide();
       $('#SubmitoptionBtn').hide();
       $('#changepasswordbtn').hide();
       $('#ResetBtn').hide();
    }
    function ShowDifferentoptions(data, event)
    {
        try {
            CpViewModel.OtpText();
            CpViewModel.OtpText('Send the MFA verification code to your registered email address?');
            //$('select option:contains("SMS")').text('Text me at ' + CpViewModel.MaskedNumber());
            //$('select option:contains("Text")').text('Text me at ' + CpViewModel.MaskedNumber());
            //$('select option:contains("Call")').text('Call me at ' + CpViewModel.MaskedNumber());
            $('select option:contains("MFA")').text('Mail me at ' + CpViewModel.appsecurity.EmailId());
            $('#Authenticationdiv').show();
            $('#AuthenticateDivshell').show();
            Hideallpasswordchangebuttons();
            $('#SubmitoptionBtn').show();
            $('#lodingimgcp').hide();
        }
        catch(e)
        {
            var msg = 'Exception: ' + error.statusText + ' | Source: error in ShowDifferentoptions() method in ProjectAuthorizeMFA.js';
            logger.logMessage(msg);
        }
    }
    function Submitoption()
    {
        try {
            CpViewModel.Popuptype('PW');
            //if ($('#ParentQuestionDropDownpasswordchange').val() == 'PhoneCall') {
            //    $('#phonecallnotifycp').html("");
            //    Hideallchangepassworddivs();
            //    $('#Phonecallauthentication').show();
            //    $('#phonecallnotifycp').html("You will receive a call on " + CpViewModel.MaskedNumber() + " with a verification procedure.");
            //    $('#lodingimgcp').show();
            //    AuthenticatewithPhoneCall();
            //}
            //else
            //{
                $('#lodingimgcp').show();
                Hideallchangepassworddivs();
                SendotpTotheuser();
                //show phonenumebr div 
            //}
        }
        catch(e)
        {
            var msg = 'Exception: ' + error.statusText + ' | Source: error in Submitoption() method in ProjectAuthorizeMFA.js';
            logger.logMessage(msg);
        }
    }
    function SendotpTotheuser() {
        try {
            $('#lodingimgcp').show();
            Hideallchangepassworddivs();
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;

            $.ajax({
                url: "/api/Account/SendMailOTPAnonymous",

                type: "POST",
                headers: headers,
            })
.success(function (jsonResult, status) {
    if (jsonResult == true) {
        logger.logSuccess('OTP has been successfully sent to the registered email address.', 'Success', system.getModuleId(CpViewModel), true);
        $('#lodingimgcp').hide();
        $('#phonecpOTPnotify').html();
        $('#phonecpOTPnotify').html("A code has been sent to you at " + CpViewModel.appsecurity.EmailId() + ".Enter that code below.");
        Hideallchangepassworddivs();
        $('#OTPAuthentication').show();
        Hideallpasswordchangebuttons();
        $('#SubmitOTPBtn').show();
//show otp 
    }
    else {
        logger.logError('Unable to send OTP, Please contact Application Administrator.', 'Error', system.getModuleId(CpViewModel), true);
    }

})
.fail(function (error, status) {
    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SendotpTotheuser() method in ProjectAuthorizeMFA.js';
    logger.logMessage(msg);
});

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SendotpTotheuser() method in AuthorizeMFA.js';
            logger.logMessage(msg);
        }
    }

    function SubmitOnetimepassword()
    {
        try{
            $('#lodingimgcp').show();
            $('#AuthenticateDivshell').hide();
            $('#changepassworddiv').hide();
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;

            $.ajax({
                url: "/api/Account/ValidateOTP",
                type: "POST",
                headers: headers,
                contentType: 'application/json',

                data: JSON.stringify
                        ({
                            ProviderName: CpViewModel.ProviderName(),
                            PhoneNumber: CpViewModel.PhoneNumber(),
                            Isverfiedphonenumber: 'true',
                            Token: CpViewModel.OTPPassword(),

                        })
            })
            .success(function (jsonResult, status) {
                if (jsonResult == true) {
                    Hideallchangepassworddivs();
                    $('#lodingimgcp').show();
                    logger.logSuccess('OTP has been successfully verified.', 'Success', system.getModuleId(CpViewModel), true);
                    ChangeUserPassword(CpViewModel.OldPassword(), CpViewModel.NewPassword());

                }
                else {
                    Hideallchangepassworddivs();
                    $('#lodingimgcp').hide();
                    $('#AuthenticateDivshell').show();
                    $('#OTPAuthentication').show();
                    logger.logError('Invalid OTP entered. Please Try again.', 'Error', system.getModuleId(CpViewModel), true);

                }

            })
.fail(function (error, status) {
    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SubmitOnetimepassword() method in ChangePassword.js';
    logger.logMessage(msg);
});
        }
        catch(e)
        {
            var msg = 'Exception' + e + ' Source | SubmitOnetimepassword() in ChangePassword.js';
            logger.logMessage(msg);
        }
    }


    function HideallButtonsChangephonenumber()
    {
        $('#validateOTPButton').hide();
        $('#Authenticatebutton').hide();
        $('#submitbutton').hide();
    }
    

    function ResetForm() {
        try {
            CpViewModel.OldPassword("");
            CpViewModel.NewPassword("");
            CpViewModel.ReEnterNewPassword("");
            $('#valErrorCp').hide();

        }
        catch (e) {
            var msg = 'Exception' + e + ' Source | ResetForm() in ChangePassword.js';
            logger.logMessage(msg);
        }
    }

    function ChangeUserPassword(OldPassword, NewPassword) {
        try {
            var key = CryptoJS.enc.Utf8.parse('8080808080808080');
            var iv = CryptoJS.enc.Utf8.parse('8080808080808080');
            var encryptedOldPassword = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(OldPassword), key,
                {
                    keySize: 128 / 8,
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                });
            $('#txtOldPassword').val(encryptedOldPassword);
            var OldPwd = $('#txtOldPassword').val();

            var encryptedNewPwd = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(NewPassword), key,
                {
                    keySize: 128 / 8,
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                });
            $('#txtNewPAssword').val(encryptedNewPwd);
            var newPwd = $('#txtNewPAssword').val();
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Account/ChangePassword",
                type: "POST",
                headers: headers,
                contentType: 'application/json',
                data: ko.toJSON({
                    OldPassword: OldPwd,
                    NewPassword: newPwd
                })
            })
        .success(ajaxSuccess)
        .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call from ChangeUserPassword() method in ChangePassword.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) { 
            try {
                if (status == 'success') {
                    CpViewModel.OTPPassword("");
                    $('#AuthenticateDivshell').hide();
                    $('#changepassworddiv').show();
                    if (CpViewModel.PageType() == "Pop-Up") {
                        $('#frmChangePassword').modal('hide');
                        logger.logSuccess('Password changed successfully.', 'Success', system.getModuleId(CpViewModel), true);

                        appsecurity.clearAuthInfo();
                        appsecurity.logout();
                        router.navigate('login')
.done(function (token) {
    $("input[name='__RequestVerificationToken']").val(token);
    appsecurity.clearAuthInfo();
    appsecurity.logout();
    router.navigate('login')
})
.fail(function (error) {
    appsecurity.clearAuthInfo();
    window.location = routeconfig.login;
});

                    }
                    else {
                        logger.logSuccess('Password changed successfully. Please login with the new password.', 'Success', system.getModuleId(CpViewModel), true);
                        //router.navigate("", true);
                        
                        appsecurity.logout();
                        appsecurity.clearAuthInfo();
                        router.navigate('login');
                    }
                    CpViewModel.PageType("Screen");
                }
                else {
                    ResetForm();
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CpViewModel), true);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess method in ChangeUserPassword() method in ChangePassword.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 400) {
                    ResetForm();
                    logger.logError('The entered old password is incorrect. Please try again.', 'Error', system.getModuleId(CpViewModel), true);
                }
                else {
                    var msg = 'Exception: ' + error + ' | Source:ajaxFail method in ChangeUserPassword() method in ChangePassword.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxFail method in ChangeUserPassword() method in ChangePassword.js';
                logger.logMessage(msg);
            }
        }

    }

    function PasswordHelp(data, event) {
        CpViewModel.PasswordHelpToolTip("Password Guidelines 1.  Minimum of eight alphanumeric characters 2.  At least one upper case character 3.  At least one non-standard character (!,*,_,etc…)")
    }

    function validatePassword(strPassword) {
        try {
            return (strPassword.match(/[a-z]/) && strPassword.match(/[A-Z]/) && strPassword.match(/\d/) && strPassword.length >= 10 && checkSpecialCharacters(strPassword));
        }
        catch (e) {
            logger.logError("Error in method: validatePassword", null, data, false);
        }
    }

    function checkSpecialCharacters(data) {
        try {
            var iChars = "!@#$%^&*()+=-[]\\\';,./{}|\":<>?~_";
            for (var i = 0; i < data.length; i++) {
                if (iChars.indexOf(data.charAt(i)) != -1) {
                    return true;
                }
            }
            return false;
        }
        catch (e) {
            logger.logError("Error in method: checkSpecialCharacters", null, data, false);
        }
    }

    function loadJsFunctions() {
        $('#txtNewPAssword').keyup(function () {
            var pswd = $(this).val();
            //validate lower case letter
            if (pswd.match(/[a-z]/)) {
                $('#lblLowerCase').removeClass('invalid').addClass('valid');
                $('#lblLowerCase>i').removeClass('fa-close').addClass('fa-check');
            } else {
                $('#lblLowerCase').removeClass('valid').addClass('invalid');
                $('#lblLowerCase>i').removeClass('fa-check').addClass('fa-close');
            }
            //validate upper case letter
            if (pswd.match(/[A-Z]/)) {
                $('#lblUpperCase').removeClass('invalid').addClass('valid');
                $('#lblUpperCase>i').removeClass('fa-close').addClass('fa-check');
            } else {
                $('#lblUpperCase').removeClass('valid').addClass('invalid');
                $('#lblUpperCase>i').removeClass('fa-check').addClass('fa-close');
            }
            //validate number
            if (pswd.match(/\d/)) {
                $('#lblNumber').removeClass('invalid').addClass('valid');
                $('#lblNumber>i').removeClass('fa-close').addClass('fa-check');
            } else {
                $('#lblNumber').removeClass('valid').addClass('invalid');
                $('#lblNumber>i').removeClass('fa-check').addClass('fa-close');
            }
            //validate punctuation
            if (checkSpecialCharacters(pswd)) {
                $('#lblPunctuation').removeClass('invalid').addClass('valid');
                $('#lblPunctuation>i').removeClass('fa-close').addClass('fa-check');
            } else {
                $('#lblPunctuation').removeClass('valid').addClass('invalid');
                $('#lblPunctuation>i').removeClass('fa-check').addClass('fa-close');
            }
            //validate the length
            if (pswd.length < 10) {
                $('#lblLength').removeClass('valid').addClass('invalid');
                $('#lblLength>i').removeClass('fa-check').addClass('fa-close');
            } else {
                $('#lblLength').removeClass('invalid').addClass('valid');
                $('#lblLength>i').removeClass('fa-close').addClass('fa-check');
            }
            //validate the better length
            if (pswd.length >= 12) {
                $('#lblBetterLength').removeClass('invalid').addClass('valid');
                $('#lblBetterLength>i').removeClass('fa-close').addClass('fa-check');
            } else {
                $('#lblBetterLength').removeClass('valid').addClass('invalid');
                $('#lblBetterLength>i').removeClass('fa-check').addClass('fa-close');
            }
        }).focus(function () {
            $('#pswd_info').show();
        }).blur(function () {
            $('#pswd_info').hide();
        });
    }

    function ValidateNewPassword(Password) {
        try {
            var Result = false;
            var SpecialCharCount = 0;
            var UpperCaseCount = 0;
            var NumberCount = 0;
            var LowerCaseCount = 0;
            for (var i = 0; i < Password.length; i++) {
                var CharCode = Password.charCodeAt(i);
                if (CharCode >= 65 && CharCode <= 90)
                    UpperCaseCount++;
                else if (CharCode >= 97 && CharCode <= 122)
                    LowerCaseCount++;
                else if (CharCode >= 48 && CharCode <= 57)
                    NumberCount++;
                else
                    SpecialCharCount++;
            }

            if (Password.length < 10 || UpperCaseCount < 1 || SpecialCharCount < 1)
                Result = false;
            else
                Result = true;
            return Result;
        }
        catch (e) {
            var msg = 'Exception' + e + ' Source | ValidateNewPassword() in ChangePassword.js';
            logger.logMessage(msg);
        }
    }

});

